import { Link } from 'react-router-dom';
import './Legal.css';

function TermsPro() {
  return (
    <div className="legal-page">
      <header className="legal-header">
        <div className="legal-header-content">
          <Link to="/" className="back-button">
            <span className="back-arrow">←</span>
            Retour
          </Link>
        </div>
      </header>

      <main className="legal-content">
        <h1 className="legal-title">Conditions Générales d'Utilisation Pro</h1>
        <p className="legal-update">Dernière mise à jour : Décembre 2024</p>

        <div className="legal-tabs">
          <Link to="/terms" className="legal-tab">Clients</Link>
          <Link to="/terms-pro" className="legal-tab active">Chauffeurs Pro</Link>
        </div>

        <p className="legal-intro">
          Bienvenue sur RideLuv Pro. Les présentes Conditions Générales d'Utilisation (« CGU Pro ») régissent votre accès et utilisation de l'application RideLuv Pro en tant que chauffeur partenaire. En créant un compte professionnel, vous acceptez d'être lié par ces conditions.
        </p>

        <section className="legal-section">
          <h2 className="legal-section-title">1. Définitions</h2>
          <p className="legal-section-text">
            « Application Pro » désigne l'application mobile RideLuv Pro destinée aux chauffeurs. « Chauffeur Partenaire » désigne tout professionnel VTC indépendant utilisant l'Application Pro. « Passager » désigne toute personne utilisant RideLuv pour commander une course. « Course » désigne le service de transport effectué par le Chauffeur Partenaire. « Commission » désigne le pourcentage prélevé par RideLuv sur chaque course.
          </p>
        </section>

        <section className="legal-section">
          <h2 className="legal-section-title">2. Conditions d'éligibilité</h2>
          <p className="legal-section-text">
            Pour devenir Chauffeur Partenaire RideLuv, vous devez : être titulaire d'une carte professionnelle VTC en cours de validité, disposer d'un véhicule conforme à la réglementation VTC (moins de 6 ans, 4 portes minimum), posséder une assurance responsabilité civile professionnelle, avoir un casier judiciaire vierge (bulletin n°3), être inscrit au registre des VTC. RideLuv se réserve le droit de vérifier ces documents à tout moment.
          </p>
        </section>

        <section className="legal-section">
          <h2 className="legal-section-title">3. Inscription et compte professionnel</h2>
          <p className="legal-section-text">
            L'inscription nécessite la fourniture de documents professionnels valides : carte professionnelle VTC, carte grise du véhicule, attestation d'assurance, extrait Kbis ou équivalent. Vous êtes responsable de la mise à jour de ces documents. RideLuv peut suspendre votre compte si vos documents expirent ou ne sont plus conformes.
          </p>
        </section>

        <section className="legal-section">
          <h2 className="legal-section-title">4. Statut d'indépendant</h2>
          <p className="legal-section-text">
            En tant que Chauffeur Partenaire, vous exercez votre activité en qualité de professionnel indépendant. Il n'existe aucun lien de subordination entre vous et RideLuv. Vous êtes libre d'accepter ou de refuser les courses proposées, de définir vos horaires de travail, et d'utiliser d'autres plateformes de mise en relation. Vous êtes seul responsable de vos obligations fiscales et sociales.
          </p>
        </section>

        <section className="legal-section">
          <h2 className="legal-section-title">5. Acceptation et réalisation des courses</h2>
          <p className="legal-section-text">
            Lorsqu'une course vous est proposée, vous pouvez l'accepter ou la refuser. Une fois acceptée, vous vous engagez à la réaliser dans les meilleures conditions. Vous devez respecter le Code de la route, les règles de courtoisie, et assurer la sécurité et le confort du passager. Les annulations répétées après acceptation peuvent entraîner des pénalités.
          </p>
        </section>

        <section className="legal-section">
          <h2 className="legal-section-title">6. Tarification et commission</h2>
          <p className="legal-section-text">
            Les tarifs des courses sont fixés par RideLuv selon la distance, la durée et la demande. Une commission est prélevée sur chaque course effectuée. Le détail de la commission est communiqué dans votre espace professionnel. Les paiements sont effectués selon les modalités définies dans votre contrat de partenariat. Les pourboires versés par les passagers vous sont intégralement reversés.
          </p>
        </section>

        <section className="legal-section">
          <h2 className="legal-section-title">7. Qualité de service</h2>
          <p className="legal-section-text">
            Vous vous engagez à maintenir un niveau de service élevé : véhicule propre et en bon état, tenue correcte, ponctualité, courtoisie envers les passagers. Un système de notation permet aux passagers d'évaluer vos prestations. Une note moyenne insuffisante peut entraîner une suspension temporaire ou définitive de votre compte.
          </p>
        </section>

        <section className="legal-section">
          <h2 className="legal-section-title">8. Assurances et responsabilités</h2>
          <p className="legal-section-text">
            Vous êtes responsable de la souscription et du maintien d'une assurance responsabilité civile professionnelle couvrant votre activité VTC. Vous êtes seul responsable des dommages causés aux passagers ou à leurs biens pendant la course. RideLuv décline toute responsabilité pour les incidents survenant pendant les courses.
          </p>
        </section>

        <section className="legal-section">
          <h2 className="legal-section-title">9. Données et géolocalisation</h2>
          <p className="legal-section-text">
            L'Application Pro collecte des données de géolocalisation pendant votre activité pour permettre le bon fonctionnement du service (attribution des courses, calcul des trajets, facturation). Ces données sont traitées conformément à notre Politique de Confidentialité Pro.
          </p>
        </section>

        <section className="legal-section">
          <h2 className="legal-section-title">10. Suspension et résiliation</h2>
          <p className="legal-section-text">
            RideLuv peut suspendre ou résilier votre compte en cas de : violation des présentes CGU, comportement inapproprié envers les passagers, fraude ou tentative de fraude, documents professionnels non valides, note moyenne insuffisante. Vous pouvez résilier votre compte à tout moment en nous contactant.
          </p>
        </section>

        <section className="legal-section">
          <h2 className="legal-section-title">11. Propriété intellectuelle</h2>
          <p className="legal-section-text">
            L'Application Pro, ses logos, marques et contenus sont la propriété exclusive de RideLuv. Vous n'êtes pas autorisé à utiliser ces éléments en dehors du cadre de votre activité de Chauffeur Partenaire.
          </p>
        </section>

        <section className="legal-section">
          <h2 className="legal-section-title">12. Droit applicable</h2>
          <p className="legal-section-text">
            Les présentes CGU Pro sont régies par le droit français. En cas de litige, et après tentative de résolution amiable, les tribunaux français seront seuls compétents. Pour toute question, contactez-nous à pro@rideluv.com.
          </p>
        </section>
      </main>

      <footer className="legal-footer">
        <p className="legal-footer-text">
          Une question ? Contactez l'équipe Pro à <a href="mailto:pro@rideluv.com" className="legal-footer-link">pro@rideluv.com</a>
        </p>
      </footer>
    </div>
  );
}

export default TermsPro;
